import React from 'react';
import SebastiaoImg from '../../assets/img/sebastião-maciel-costa.png';
import Slider from "react-slick";
import './SlideCard.css';

export default class SlideCard extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            positionSlide: 1
        }
    }

    render() {
        let settings = {
            dotsClass: "card-dots",
            autoPlay: true,
            autoPlaySpeed: 3000,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        };
        return (
            <div className="container-container mb-4">

                <Slider {...settings}>
                    <div className="container">
                        <div className="row card__author">
                            <div className=" col-12 col-md-4 col-lg-4 col-xl-4 card__author__image">
                                <img src="https://res.cloudinary.com/uxmob/image/upload/v1555640465/xq7unsqlv89pbbhq6vdj.jpg" alt="foto-author" />
                            </div>
                            <div className="col-12 col-md-7 col-xl-7 card__author__text">
                                <p>
                                  A editora A5 é uma realizadora de sonhos com muito comprometimento e cuidado com os autores.
Eu não penso em outra editora para lançar meu segundo livro.
Meu livro foi lançado em 28 de junho de 2018 e em dezembro não tinha mais!
Gratidão A5!
                            </p>
                                <p><strong >Ticiana Oliveira</strong>, autora do livro "Meu conto de falhas".</p>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row card__author">
                            <div className=" col-12 col-md-4 col-lg-4 col-xl-4 card__author__image">
                                <img src="https://res.cloudinary.com/uxmob/image/upload/v1555640502/b5evhbzg8ascxywvjnp0.jpg" alt="foto-author" />
                            </div>
                            <div className="col-12 col-md-7 col-xl-7 card__author__text">
                                <p>
                                Atendimento de extrema qualidade e preocupação em todos os detalhes. A editora está de parabéns pelo profissionalismo e pelo belíssimo trabalho que vem desenvolvendo em prol da produção literária da região
                            </p>
                                <p><strong >Rodrigo Muniz</strong>, autor do livro "Diário das Mil Faces: baseado em fatos reais".</p>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/SlideCard/SlideCard.js